import { ObjectOps } from '../lift';
/**
 * Adds a key/value to this heterogeneous object.
 * To add a (nullable) key to an object while preserving its type, use "update()" instead.
 * To add a key to a homogeneous key/value object, use "assoc" instead.
 */
export function add(key, value) {
    var obj = this.value(), result = {};
    Object.keys(obj).forEach(function (key) { result[key] = obj[key]; });
    result[key] = value;
    return new ObjectOps(result);
}
ObjectOps.prototype.add = add;
//export function add<A, K extends string, V>(this: ObjectOps<A>, key: K, value: V): ObjectOps<A & Record<K, V>> {
